type EnvName =
  'development' | 'qa' | 'sit' | 'staging' | 'homolog' | 'production' | 'mock'

const envName = (import.meta.env.VITE_ENV_NAME ?? 'development') as EnvName

export function assertApiUrl(
  apiUrl: string | undefined,
  isProduction: boolean,
): void {
  if (!apiUrl) return

  if (apiUrl.startsWith('https://')) return

  if (!isProduction) {
    const isLocalHttp =
      apiUrl.startsWith('http://localhost') ||
      apiUrl.startsWith('http://127.0.0.1')
    if (isLocalHttp || apiUrl.startsWith('/')) return
  }

  throw new Error(
    `[env] VITE_API_URL inválida: "${apiUrl}". ` +
      'Em produção a API deve usar https://. ' +
      'Em desenvolvimento é permitido http://localhost.',
  )
}

const apiUrl = import.meta.env.VITE_API_URL as string | undefined
const isProduction = envName === 'production'

assertApiUrl(apiUrl, isProduction)

export const env = {
  envName,

  production: isProduction,

  mock: import.meta.env.VITE_MOCK === 'true',

  showUnreadyFeatures:
    envName === 'development' ||
    envName === 'mock' ||
    import.meta.env.VITE_MOCK === 'true',

  appVersion: import.meta.env.VITE_APP_VERSION ?? '',

  apiUrl,

  wsUrl: import.meta.env.VITE_WS_URL,

  authRefreshEnabled: import.meta.env.VITE_AUTH_REFRESH_ENABLED !== 'false',
} as const
